module.exports = __webpack_public_path__ + "media/stylesheets/images/staff_3-c663bcf551bba3eb2a572d854735529e.jpg";